;(function( $ ) {
    var container = $( '.masonry' ),
        getTallest = function( $node ) {
            var heights = [];

            $node.children().each( function() {
                heights.push( this.scrollHeight );
            } );

            // Find the biggest number from all the heights
            return heights.reduce( function( a, b ) {
                return Math.max( a, b );
            } );
        },
        addHeight = function() {
            if ( container.length && $( window ).width() >= 1024 ) {
                container.each( function() {
                    var $this = $( this ), tallest;
                    // To make sure we don't get runaway heights each time the page is resizes we'll reset the values
                    $this.css( { '--tallest': '0px', height: 'auto' } );

                    // Find the tallest child node
                    tallest = getTallest( $this );

                    // Set the height var and container height
                    $this.css( { '--tallest': tallest + 'px', height: '' } );
                } );
            }
        },
        evnt;

    $( document ).ready( function() {
        addHeight();

        $( window ).on( 'resize', function() {
            // Set heights only after the page has stopped resizing for at least 100ms
            clearTimeout( evnt );
            evnt = setTimeout( addHeight, 100 );
        } );
    } );

}( jQuery ));
